import React from "react";
import { Status } from "types/status";

export const newColors = {
  background: "#f8f7f5",
  primary: "#e77c1a",
  primaryLight: "#eb9647",
  secondary: "#687aca",
  text: "#59534F",
  textLight: "#6B6B6B",
  iconGray: "#858585",
  border: "#E1DDD6",
  white: "#FFFFFF",
  hover: "#D5DEE6",
  selected: "#f6c496",
  active: "#4f65b3",
  red: "#ff0000",
  errorZone: "#fee4e5",
  errorText: "#f8535c",
  warningZone: "#fde9cf",
  warningText: "#ffca28",
  changeZone: "#e6ffef",
  newlyZone: "#e3f2ff",
  black: "#000000",
  blue: "#1a77e4",
  green: "#4db56a",
  defaultLink: "#0000ee",
  announceBackground: "#fcd882",
  mention: "#0b57d0",
} as const;

export type NewColors = keyof typeof newColors;

export const statusLabelColor: {
  [key in Status]: {
    text: React.CSSProperties["color"];
    background: React.CSSProperties["background"];
  };
} = {
  NOT_ASSIGNED: { text: "#e7e7e7", background: "#c87879" },
  ASSIGNING: { text: "#ffffff", background: "#9d67b1" },
  DOING: { text: "#ffffff", background: "#6b7bc3" },
  DONE: { text: "#ffffff", background: "#88add2" },
  CANCELED: { text: "#939393", background: "#e7e7e7" },
  FINISHED: { text: "#e7e7e7", background: "#939393" },
  NOT_STARTED: { text: "#ffffff", background: "#87b573" },
  MONITOR_NOT_ENTERED: { text: "#e7e7e7", background: "#c5ab37" },
  MONITOR_ENTERD: { text: "#ffffff", background: "#99781b" },
  NOT_STARTED_CANCEL: { text: "#939393", background: "#e7e7e7" },
  STARTED_CANCEL: { text: "#939393", background: "#e7e7e7" },
  INTERVIEWER_CANCEL: { text: "#939393", background: "#e7e7e7" },
  MONITOR_CANCEL: { text: "#939393", background: "#e7e7e7" },
} as const;
